import React from 'react'
import { Done } from '@mui/icons-material'
import { Input, Modal } from 'antd'
import { useAtom } from 'jotai'
import userClient from '../../../Api/Lirari/Clients/userClient'
import { useAuth0 } from '@auth0/auth0-react'
import { myUserAtom } from '../../../State/Musician/myUserAtom'
import { Offering } from '../../../Api/Lirari/Types/offering'
import { offeringsAtom } from '../../../State/Musician/offeringsAtom'
import { unauthenticatedUserAtom } from '../../../State/Musician/unauthenticatedUserAtom'
import { useParams } from 'react-router-dom'

const { TextArea } = Input

const MusicianAbout = ({ editMode }: { editMode: boolean }) => {
  const [myUser, setMyUser] = useAtom(myUserAtom)
  const [unauthenticatedUser] = useAtom(unauthenticatedUserAtom)
  const { isAuthenticated, getAccessTokenSilently } = useAuth0()
  const [allOfferings] = useAtom(offeringsAtom)
  const { uid: userId } = useParams()

  const [isModalOpen, setIsModalOpen] = React.useState(false)

  const about =
    'Born in Kufor Nimeh. As a child I trained in the Edward Said Conservatory of Music playing the Buzoq. Now I am furthering my studies of music teaching by taking the ESNCM music diplome course. I enjoy teaching and performing Arabic music.'
  const [offerings, setOfferings] = React.useState<{ offering: Offering }[]>([])

  const setOffering = (offering: Offering) => {
    if (offerings.some((o) => o.offering.id == offering.id)) {
      setOfferings(offerings.filter((value) => value.offering.id != offering.id))
    } else {
      setOfferings([...offerings, { offering }])
    }
  }

  React.useEffect(() => {
    myUser.id == userId
      ? setOfferings(myUser.userOfferings)
      : unauthenticatedUser.id == userId
        ? setOfferings(unauthenticatedUser.userOfferings)
        : setOfferings([
            { offering: { id: '10239', name: 'Teaching' } },
            { offering: { id: '10232', name: 'Performance' } },
          ])
  }, [userId, myUser.id, myUser.userOfferings, unauthenticatedUser.id, unauthenticatedUser.userOfferings])

  const isOfferingSelected = (offering: Offering): boolean => {
    return offerings.some((o) => o.offering.id == offering.id)
  }

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = async () => {
    if (isAuthenticated) {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'user:all',
        },
      })
      await userClient.updateUser(userId!, { about: myUser.about }, token)
      await userClient.overwriteUserOfferings(
        userId!,
        offerings.map((o) => o.offering),
        token,
      )
      setOfferings(offerings)
    }
    setIsModalOpen(false)
  }

  return (
    <>
      <Modal centered open={isModalOpen} closable={false} footer={[]}>
        <div className="flex flex-col items-center w-full">
          <p className="title-small mb-0">About</p>
          <TextArea
            autoSize={{ minRows: 4, maxRows: 6 }}
            variant="borderless"
            className="text-area"
            placeholder="More information about my work or myself"
            value={myUser.about}
            onChange={(e) => setMyUser({ ...myUser, about: e.target.value })}
            maxLength={300}
          />
          <p className="title-small">Offerings</p>
          <div className="flex flex-wrap gap-3 px-3.5 justify-center">
            {allOfferings.map((value, index) => (
              <p
                className={`align-center justify-center p-2.5 m-0 rounded-3xl bg-black ${isOfferingSelected(value) ? 'border-2 b-white' : null}`}
                key={index}
                onClick={() => setOffering(value)}
              >
                {value.name}
              </p>
            ))}
          </div>
          <button
            disabled={about.length == 0 ? true : false}
            className={`flex p-0 mt-2.5 justify-center items-center size-12 rounded-full bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black ${about.length == 0 ? 'cursor-no-drop' : 'cursor-pointer'}`}
            onClick={handleOk}
          >
            <Done />
          </button>
        </div>
      </Modal>
      <div
        className={`bg-gradient-to-b from-[#494949] to-[#242424] overflow-y-auto rounded-lg min-[1180px]:min-w-[370px] max-[1020px]:min-h-[370px] lg:w-[35vw] w-full lg:min-w-[440px] lg:max-h-[340px] flex flex-col items-center lg:pb-0 pb-[4vh] mx-4 lg:mx-0 ${editMode ? 'cursor-pointer' : ''}`}
        onClick={() => (editMode ? showModal() : null)}
      >
        <div className="flex flex-col items-center h-[50%]">
          <p className="title-small mb-0 py-[5px]">About</p>
          <p className="mb-0 px-3.5 text-base">
            {userId == myUser.id ? myUser.about : userId == unauthenticatedUser.id ? unauthenticatedUser.about : about}
          </p>
        </div>
        {offerings.length == 0 ? null : (
          <div className="flex flex-col items-center h-[50%]">
            <p className="title-small pb-[5px]">Offerings</p>
            <div className="flex flex-wrap gap-3 px-3.5 justify-center">
              {offerings.map((value, index) => (
                <p className="align-center justify-center p-2.5 m-0 rounded-3xl bg-black" key={index}>
                  {value.offering.name}
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default MusicianAbout
